import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import PipelineCard from './PipelineCard';

export const STAGE_META = {
  APPLIED:   { label: 'Applied',   color: 'bg-navy-700'  },
  SCREENING: { label: 'Screening', color: 'bg-teal-500'  },
  TECHNICAL: { label: 'Technical', color: 'bg-teal-600'  },
  HR:        { label: 'HR Round',  color: 'bg-teal-700'  },
  OFFER:     { label: 'Offer',     color: 'bg-amber-500' },
  HIRED:     { label: 'Hired',     color: 'bg-teal-500'  },
  REJECTED:  { label: 'Rejected',  color: 'bg-rose-500'  },
};

export default function PipelineColumn({ stage, cards, activeId, onCardSelect }) {
  const meta = STAGE_META[stage] || { label: stage, color: 'bg-ink-faint' };
  const ids  = cards.map(c => c.id);
  const { setNodeRef, isOver } = useDroppable({ id: stage });

  return (
    <div className="flex flex-col w-64 flex-shrink-0">
      <div className="flex items-center gap-2 mb-3 px-1">
        <span className={`w-2 h-2 rounded-full ${meta.color}`} />
        <span className="text-xs font-semibold text-ink uppercase tracking-wider">
          {meta.label}
        </span>
        <span className="ml-auto text-[11px] font-mono font-semibold text-ink-faint bg-surface
                         border border-line rounded-full px-2 py-0.5">
          {cards.length}
        </span>
      </div>

      <SortableContext items={ids} strategy={verticalListSortingStrategy}>
        <div
          ref={setNodeRef}
          className={`flex-1 min-h-32 rounded-xl bg-canvas border
                     p-2.5 space-y-2 transition-colors ${
                       isOver
                         ? 'border-teal-400 bg-teal-50/50 ring-2 ring-teal-200/50 ring-offset-0'
                         : 'border-line'
                     }`}
          data-stage={stage}
        >
          {cards.map(card => (
            <PipelineCard
              key={card.id}
              card={card}
              isDragging={activeId === card.id}
              onSelect={onCardSelect}
            />
          ))}
          {cards.length === 0 && (
            <p className="text-xs text-ink-faint text-center mt-6">Drop here</p>
          )}
        </div>
      </SortableContext>
    </div>
  );
}
